/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    SearchedPressReleasesResponseAllOf,
    SearchedPressReleasesResponseAllOfFromJSON,
    SearchedPressReleasesResponseAllOfFromJSONTyped,
    SearchedPressReleasesResponseAllOfToJSON,
} from './SearchedPressReleasesResponseAllOf';
import {
    SearchedPressReleasesResponseAllOfData,
    SearchedPressReleasesResponseAllOfDataFromJSON,
    SearchedPressReleasesResponseAllOfDataFromJSONTyped,
    SearchedPressReleasesResponseAllOfDataToJSON,
} from './SearchedPressReleasesResponseAllOfData';

/**
 * 検索したプレスリリース一覧を取得したときのレスポンス
 * @export
 * @interface SearchedPressReleasesResponse
 */
export interface SearchedPressReleasesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof SearchedPressReleasesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof SearchedPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {SearchedPressReleasesResponseAllOfData}
     * @memberof SearchedPressReleasesResponse
     */
    data: SearchedPressReleasesResponseAllOfData;
}

export function SearchedPressReleasesResponseFromJSON(json: any): SearchedPressReleasesResponse {
    return SearchedPressReleasesResponseFromJSONTyped(json, false);
}

export function SearchedPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchedPressReleasesResponseAllOfDataFromJSON(json['data']),
    };
}

export function SearchedPressReleasesResponseToJSON(value?: SearchedPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchedPressReleasesResponseAllOfDataToJSON(value.data),
    };
}

